export default "__VITE_ASSET__a7ecfb81__"